<div class="w-full">
  <mat-form-field
    class="w-full"
    [subscriptSizing]="'dynamic'"
    hideRequiredMarker="true">
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      class="w-full"
      [formControl]="searchControl"
      [placeholder]="'Search...'"
      (keydown)="onKeydown($event)"
      #barSearchInput />
  </mat-form-field>

  <!-- Search Results List -->
  <div class="mt-2" *ngIf="resultSets && resultSets.length > 0">
    <div
      class="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-600 rounded-lg shadow-lg max-h-96 overflow-y-auto">
      <ng-container *ngFor="let resultSet of resultSets; trackBy: trackByFn">
        <ng-container
          *ngFor="let result of resultSet.results; trackBy: trackByFn">
          <div
            class="p-3 sm:p-4 border-b border-gray-100 dark:border-slate-700 last:border-b-0 hover:bg-gray-50 dark:hover:bg-slate-700 cursor-pointer transition-colors duration-200"
            (click)="onRecordClickEvent(result)">
            <!-- Quote Request -->
            <ng-container *ngIf="resultSet.id === 'quote_requests'">
              <div class="flex flex-col sm:flex-row sm:items-start gap-3">
                <span
                  class="bg-slate-400 px-2 py-1 rounded-md shrink-0 text-xs text-white font-medium self-start">
                  {{ result.order_number }}
                </span>
                <div
                  class="flex flex-col md:flex-row items-start md:items-center space-x-3 gap-1 md:gap-0">
                  <span
                    [innerHTML]="
                      result.principal_name
                        | highlightSearch: searchControl.value
                    "
                    class="text-md font-medium text-gray-900 dark:text-white"></span>
                  <mat-icon
                    class="text-gray-400 hidden md:block dark:text-gray-500">
                    chevron_right
                  </mat-icon>
                  <span
                    [innerHTML]="
                      result.client_name | highlightSearch: searchControl.value
                    "
                    class="text-md font-medium text-gray-900 dark:text-white"></span>
                  <mat-icon
                    class="text-gray-400 hidden md:block dark:text-gray-500">
                    chevron_right
                  </mat-icon>
                  <span
                    [innerHTML]="
                      result.bond_label | highlightSearch: searchControl.value
                    "
                    class="text-md font-medium text-gray-900 dark:text-white"></span>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- No Results Message -->
  <div
    class="mt-2"
    *ngIf="
      resultSets &&
      resultSets.length === 1 &&
      resultSets[0].results.length === 0 &&
      searchControl.value &&
      searchControl.value.length >= minLength
    ">
    <div
      class="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-600 rounded-lg shadow-lg p-6">
      <div class="text-center text-gray-500 dark:text-gray-400">
        <mat-icon class="mb-2 text-2xl">search_off</mat-icon>
        <p class="text-sm">No results found for "{{ searchControl.value }}"</p>
        <p class="text-xs mt-1">Try adjusting your search terms</p>
      </div>
    </div>
  </div>
</div>
